module.exports = __webpack_public_path__ + "img/videoimg2.6b53cb92.jpg";